export const products = [
  {
    key: "android-app",
    accent: "#29ABE2",
    accentDark: "#1a7fad",
    iconName: "android",
    statusLabel: "Live",
    name: "Trend Genie AI Crypto Signals App",
    shortName: "Android App",
    path: "/ai-crypto-signals-app",
    externalUrl:
      "https://play.google.com/store/apps/details?id=com.entiresolutions.trendgenie",
    domainLabel: "Google Play",
    heroKicker: "Flagship Product",
    seoTitle:
      "Best AI Crypto Signals App for Android 2026 - Trend Genie | 7-Day Free Trial, Then $10/Month",
    metaDescription:
      "Download Trend Genie, the best AI crypto signals app for Android. Get real-time signals with entry, TP1/TP2, stop-loss, instant alerts, live charts, and portfolio tracking. Start with a 7-day free trial, then only $10/month. Trusted by 10,000+ traders with 83%+ win rate. Trade smarter today.",
    primaryKeyword: "best AI crypto signals app for Android 2026",
    secondaryKeywords: [
      "AI crypto signals app",
      "real-time crypto signals app",
      "crypto trading signals app",
      "AI trading signals Android",
      "$10 month crypto signals subscription",
      "free 7 day crypto signals trial",
    ],
    summary:
      "A dedicated Android AI crypto signals app with real-time entry points, TP1 and TP2 targets, stop-loss levels, instant alerts, live charts, and portfolio tracking.",
    overview:
      "Trend Genie AI Crypto Signals App helps traders act faster on Android by delivering real-time AI-powered crypto signals with precise entry points, TP1 and TP2 targets, stop-loss levels, and instant push notifications. It is built for users who want a mobile-first trading workflow that removes emotion and guesswork from decision-making.",
    whyItMatters:
      "In the fast-moving crypto market, timing is everything. Trend Genie scans price action, market sentiment, and market structure faster than manual analysis and turns that into clear, actionable trade setups. Instead of vague alerts, traders get structured signals they can understand immediately on their phone.",
    features: [
      "Real-time AI signals engine with exact entry, TP1, TP2, and stop-loss levels",
      "Instant push notifications for high-probability opportunities",
      "Live charts, trend views, and heatmap views for faster market scanning",
      "Personalized watchlists and portfolio tracker",
      "Market scanner, signal feed, and active signal monitoring",
      "Beginner-friendly Android interface with fast loading and clean structure",
      "7-day full-access free trial before the $10 per month plan",
    ],
    bestFor: [
      "Beginner traders learning to spot trends without overwhelm",
      "Experienced traders who want faster, data-backed setups",
      "Busy professionals who need alerts on the go",
      "Android users who want a complete mobile trading workflow",
    ],
    useCases: [
      "Receiving instant alerts when a new high-probability setup appears",
      "Following clean entry, TP1, TP2, and stop-loss levels without guesswork",
      "Checking active signals and heatmaps during the trading day",
      "Using RugShield before acting on a DeFi token and discussing setups on Social",
      "Running a mobile-first workflow from signal discovery to execution planning",
    ],
    access: [
      "Available on Android through Google Play",
      "7-day free trial with full access",
      "Then $10 per month with no hidden fees",
      "Cancel anytime",
    ],
    faqs: [
      {
        question: "How accurate are the signals?",
        answer:
          "Trend Genie reports an 83%+ win rate on tracked signals. No signal system can guarantee outcomes, but the app is built to deliver structured, data-backed setups instead of emotional guesswork.",
      },
      {
        question: "What happens after the 7-day free trial?",
        answer:
          "After the trial, access continues on the paid subscription at $10 per month. Users can cancel anytime.",
      },
      {
        question: "Does the app include stop-loss and multiple take-profits?",
        answer:
          "Yes. Signals include exact entry levels, TP1, TP2, and a stop-loss so traders can see the full setup clearly before acting.",
      },
      {
        question: "Is this financial advice?",
        answer:
          "No. Trend Genie provides information and decision support only. Always do your own research and never risk more than you can afford to lose.",
      },
      {
        question: "Which cryptocurrencies are covered?",
        answer:
          "The app is positioned around Bitcoin, Ethereum, and a large range of altcoins so users can monitor far more than just a few large-cap assets.",
      },
      {
        question: "Is the app only for Android users?",
        answer:
          "The dedicated signals product is currently Android-first and distributed through Google Play.",
      },
      {
        question: "Do I get instant alerts when the app is closed?",
        answer:
          "Yes. Instant push notifications are part of the core product experience when a high-probability setup appears.",
      },
      {
        question: "Can beginners use the app easily?",
        answer:
          "Yes. The interface is designed to be simple enough for beginners while still powerful enough for experienced traders who want speed and structure.",
      },
      {
        question: "Can I cancel the subscription anytime?",
        answer:
          "Yes. The subscription is monthly after the free trial and is designed without long-term lock-in.",
      },
      {
        question: "How should I use Trend Genie with the rest of the ecosystem?",
        answer:
          "Start with the app for signal discovery, use RugShield before acting on a DeFi token, and discuss trades on Trend Genie Social while earning TGEN rewards.",
      },
    ],
    relatedKeys: ["rugshield-web", "social", "nova"],
  },
  {
    key: "rugshield-web",
    accent: "#10b981",
    accentDark: "#0a7a59",
    iconName: "rugshield",
    statusLabel: "Live",
    name: "RugShield DeFi Scanner",
    shortName: "RugShield",
    path: "/rugshield-defi-scanner",
    externalUrl: "https://app.trendgenie.io",
    domainLabel: "app.trendgenie.io",
    heroKicker: "DeFi Safety Product",
    seoTitle:
      "RugShield DeFi Scanner - Free AI Token Safety Checker for Ethereum and BNB Chain",
    metaDescription:
      "Protect your crypto investments with RugShield, the free AI-powered DeFi safety scanner by Trend Genie. Instantly detect rug pulls, honeypots, and smart contract risks on Ethereum and BNB Chain. Read-only tool with beginner and pro modes. Scan any token in seconds with no wallet connection needed.",
    primaryKeyword: "free DeFi rug pull scanner",
    secondaryKeywords: [
      "RugShield DeFi scanner",
      "honeypot checker BNB Chain",
      "rug pull detector Ethereum",
      "AI token safety checker",
      "free DeFi scanner",
      "read only DeFi safety tool",
    ],
    summary:
      "A free AI-assisted DeFi safety scanner that helps users detect rug pulls, honeypots, and suspicious token contract risks on Ethereum and BNB Chain before they buy.",
    overview:
      "RugShield is Trend Genie's free AI-assisted DeFi safety scanner built for traders who want a clear answer before they ape into a token. It turns complex on-chain checks into a simple traffic-light risk score, then explains what the result means in either beginner-friendly language or deeper technical detail. The scanner supports Ethereum and BNB Chain, runs in seconds, never asks for a wallet connection, and helps users catch honeypots, rug-pull patterns, and risky contract behavior before capital is exposed.",
    whyItMatters:
      "The DeFi space moves fast and thousands of tokens launch every week, but speed without verification gets traders rekt. Rug pulls, honeypots, and malicious contract functions still drain millions from unsuspecting users because most people cannot manually audit smart contracts under pressure. RugShield solves that by giving traders a fast, read-only early-warning layer before they commit capital. Use it alongside the Trend Genie AI Signals App so a good setup also passes a basic safety check.",
    features: [
      "AI-assisted traffic-light scoring with green, amber, and red risk states",
      "Honeypot detection for Ethereum and BNB Chain tokens",
      "Ownership and rug pattern analysis for risky contract behavior",
      "Beginner mode and Pro mode for simple or technical explanations",
      "Lightning-fast scans in roughly 2 to 5 seconds",
      "Read-only design with no wallet connection, approvals, or signatures",
      "Clear signal cards for each risk area inside the report",
    ],
    bestFor: [
      "DeFi traders who want a fast pre-trade risk check before buying a token",
      "Newcomers who need plain-English explanations instead of raw contract data",
      "Experienced users who want quick technical signal cards without opening ten tabs",
      "Trend Genie app users who want to verify token safety before acting on a signal",
    ],
    useCases: [
      "Checking a meme coin contract before buying after a social media hype spike",
      "Cross-verifying a token found through the Trend Genie AI Signals App",
      "Learning what a safer token looks like by scanning known assets such as USDT or USDC",
      "Sharing scan results with friends or communities before making a DeFi decision",
    ],
    access: [
      "Completely free to use",
      "Available in any browser at app.trendgenie.io",
      "No wallet connection or account required for scanning",
      "Built to pair with the Trend Genie Android app, Social, and Nova",
    ],
    faqs: [
      {
        question: "Is RugShield completely free?",
        answer:
          "Yes. RugShield is 100% free to use with no hidden limits or paywalls. It is built as an educational DeFi safety tool for the wider community.",
      },
      {
        question: "Which blockchains does RugShield support?",
        answer:
          "RugShield currently supports Ethereum and BNB Chain. Additional chain support may be added as the product expands.",
      },
      {
        question: "Do I need to connect my wallet?",
        answer:
          "No. RugShield is a read-only scanner and never asks for wallet approvals, signatures, or private keys. You can scan contracts without putting funds at risk.",
      },
      {
        question: "What does the traffic light score mean?",
        answer:
          "Green means lower detected risk, amber means caution with details worth reviewing, and red means higher-risk signals were detected. It is an early-warning layer, not a guarantee of safety.",
      },
      {
        question: "Is this financial advice?",
        answer:
          "No. RugShield is an educational and informational tool only. Always do your own research and verify directly on Etherscan or BscScan before investing.",
      },
      {
        question: "How accurate is the scanner?",
        answer:
          "RugShield uses on-chain data and external risk signals to catch common red flags, but no scanner catches everything. It should be treated as one layer in a broader due-diligence process.",
      },
      {
        question: "Can I scan any token?",
        answer:
          "You can scan ERC-20 style tokens on supported chains. A good way to understand the tool is to test well-known tokens such as USDT or USDC first, then compare that with higher-risk tokens.",
      },
      {
        question: "What is the difference between Beginner mode and Pro mode?",
        answer:
          "Beginner mode translates risks into plain English so new traders can understand what matters. Pro mode focuses on direct technical detail for faster expert review.",
      },
      {
        question: "How long does a scan take?",
        answer:
          "Most scans complete in about 2 to 5 seconds depending on network conditions and public RPC responsiveness.",
      },
      {
        question: "Are there plans for more RugShield features?",
        answer:
          "Yes. The roadmap includes LP lock status, liquidity health, deployer share analysis, top-holder distribution, whale warnings, behavioral alerts, and notification options.",
      },
      {
        question: "How does RugShield pair with the Trend Genie app?",
        answer:
          "Use the Android app to discover setups and trending coins, then run the token through RugShield before entering any DeFi position. That creates a safer workflow.",
      },
      {
        question: "Where can I report issues or suggest features?",
        answer:
          "You can reach the team at support@trendgenie.io or join Trend Genie Social to share product feedback and suggestions.",
      },
    ],
    relatedKeys: ["android-app", "social", "nova"],
  },
  {
    key: "social",
    accent: "#8B5CF6",
    accentDark: "#6d35d4",
    iconName: "social",
    statusLabel: "Live",
    name: "Trend Genie Social",
    shortName: "Social",
    path: "/products/social",
    externalUrl: "https://social.trendgenie.io",
    domainLabel: "social.trendgenie.io",
    heroKicker: "Community Product",
    seoTitle: "Trend Genie Social | Crypto Community Platform for Traders",
    metaDescription:
      "Join the Trend Genie crypto community. Share trade ideas, discuss coins, follow market narratives, and earn TGEN rewards through active participation. Free to join.",
    primaryKeyword: "crypto community platform",
    secondaryKeywords: [
      "crypto social network for traders",
      "Web3 discussion platform",
      "crypto trading community",
      "TGEN rewards platform",
      "crypto market discussion app",
    ],
    summary:
      "A dedicated crypto community platform where traders share ideas, discuss coins, follow market narratives, and earn TGEN rewards through active participation in the ecosystem.",
    overview:
      "Trend Genie Social is the community and discussion layer of the Trend Genie ecosystem, available at social.trendgenie.io. It gives traders a dedicated space to share coin ideas, post market updates, react to community content, and follow what the most active users are discussing. Unlike general crypto Twitter threads or Reddit forums, Trend Genie Social is built around the same ecosystem as the signals app and RugShield scanner, so the conversation is focused, relevant, and tied to real trading activity. Active participation also connects with the TGEN token reward system, giving users a reason to stay engaged beyond just consuming content.",
    whyItMatters:
      "Trading alone is isolating and following noisy social media for ideas leads to poor decisions. Trend Genie Social fixes this by creating a focused, crypto-specific community where conversation is tied directly to the products you are already using. When you spot a signal in the Android app or run a RugShield scan, you can jump to Social to discuss it, share your analysis, and see what the community thinks within the same product ecosystem.",
    features: [
      "Crypto-focused community feed built for active traders",
      "Post updates, share trade ideas, and react to community content",
      "Discussion threads around specific coins and market narratives",
      "Referral system and activity-driven TGEN token reward earning",
      "Integration with the wider Trend Genie product ecosystem",
    ],
    bestFor: [
      "Traders who want a focused crypto community without the noise of Twitter or Reddit",
      "Users who want to discuss coin ideas with others in the Trend Genie ecosystem",
      "Anyone looking to earn TGEN tokens through referrals and active community engagement",
      "New traders who want to learn from experienced community members",
    ],
    useCases: [
      "Posting a trade idea after spotting a signal in the Trend Genie Android app",
      "Discussing a trending market narrative with other active community members",
      "Sharing a RugShield scan result to warn others about a risky token",
      "Earning TGEN rewards by referring new users and staying active on the platform",
    ],
    access: [
      "Free to join at social.trendgenie.io",
      "Connect with a wallet for full ecosystem participation and rewards",
      "Integrated with the TGEN token reward and airdrop system",
      "Works alongside the Android app and RugShield for a complete ecosystem experience",
    ],
    faqs: [
      {
        question: "What is Trend Genie Social?",
        answer:
          "Trend Genie Social is the community platform of the Trend Genie ecosystem. It gives traders a space to post updates, share coin ideas, discuss market narratives, and engage with the community. It also integrates with the TGEN token reward system so active users can earn through participation.",
      },
      {
        question: "How is Trend Genie Social different from Twitter or Reddit?",
        answer:
          "Trend Genie Social is built specifically for the Trend Genie ecosystem. The community is focused on the same coins, signals, and tools that ecosystem users are actively trading, which makes discussions more relevant and actionable than general crypto social media.",
      },
      {
        question: "Can I earn TGEN tokens on Trend Genie Social?",
        answer:
          "Yes. Active participation on Trend Genie Social connects with the TGEN reward system. Referring new users and staying engaged in the community are key ways to accumulate TGEN tokens as part of the ecosystem.",
      },
      {
        question: "Is Trend Genie Social free to join?",
        answer:
          "Yes. You can join Trend Genie Social for free at social.trendgenie.io. Connecting a wallet unlocks full ecosystem participation including rewards and referral flows.",
      },
    ],
    relatedKeys: ["android-app", "rugshield-web", "nova"],
  },
  {
    key: "nova",
    accent: "#F7941D",
    accentDark: "#c4700d",
    iconName: "nova",
    statusLabel: "Coming Soon",
    name: "Trend Genie Nova",
    shortName: "Nova",
    path: "/products/nova",
    externalUrl: "https://nova.trendgenie.io",
    domainLabel: "nova.trendgenie.io",
    heroKicker: "Emerging Product",
    seoTitle:
      "Trend Genie Nova | Advanced AI Crypto Intelligence Platform (Coming Soon)",
    metaDescription:
      "Trend Genie Nova is the next evolution of the ecosystem - a deeper AI intelligence layer with advanced market analysis, expanded workflows, and premium trading capabilities. Coming soon.",
    primaryKeyword: "advanced AI crypto intelligence platform",
    secondaryKeywords: [
      "Trend Genie Nova",
      "advanced crypto trading tools",
      "AI market intelligence platform",
      "premium crypto analysis suite",
      "crypto workflow automation",
    ],
    summary:
      "The next evolution of the Trend Genie ecosystem. Nova is an advanced AI intelligence platform expanding beyond signals into deeper market analysis, premium tools, and automated trading workflows.",
    overview:
      "Trend Genie Nova is the upcoming advanced product branch within the Trend Genie ecosystem. While the Android app handles real-time signal generation and RugShield covers DeFi safety, Nova is designed to operate at a deeper level by providing more powerful AI-driven market intelligence, expanded analytical workflows, and advanced tooling for serious traders who need more than standard crypto signals. Nova is positioned as the premium intelligence layer that bridges the core product suite with sophisticated market analysis capabilities. It will be available at nova.trendgenie.io when launched.",
    whyItMatters:
      "The crypto market moves fast and the tools available to most retail traders are limited compared to what institutional players use. Trend Genie Nova is being built to close that gap by giving individual traders access to advanced market intelligence and analytical workflows that go beyond the standard signals experience. If you are already using the Android app and RugShield, Nova represents the natural next step into deeper, more powerful crypto analysis.",
    features: [
      "Advanced AI market intelligence beyond standard signal generation",
      "Expanded analytical workflows for deeper crypto market research",
      "Premium tooling designed for experienced and serious traders",
      "Highest-tier product in the Trend Genie ecosystem",
      "Designed to connect with existing Android app and RugShield workflows",
    ],
    bestFor: [
      "Experienced traders ready to move beyond basic crypto signals",
      "Users who want deeper AI-powered market intelligence in one platform",
      "Trend Genie users looking for the next level after the core Android app",
      "Serious traders who need advanced tools without institutional-level pricing",
    ],
    useCases: [
      "Running deeper market analysis beyond what the standard signals app provides",
      "Using advanced workflows to build a more structured and systematic trading process",
      "Accessing premium intelligence features as a natural upgrade from the Android app",
      "Staying ahead of the Trend Genie ecosystem roadmap as Nova features roll out",
    ],
    access: [
      "Coming soon at nova.trendgenie.io",
      "Will integrate with existing Trend Genie accounts and the TGEN ecosystem",
      "Follow Trend Genie updates to be notified when Nova launches",
      "Designed as a natural upgrade path from the Android app and RugShield",
    ],
    faqs: [
      {
        question: "What is Trend Genie Nova?",
        answer:
          "Trend Genie Nova is the upcoming advanced intelligence platform within the Trend Genie ecosystem. It is designed to provide deeper AI-powered market analysis, expanded trading workflows, and premium tools for serious traders who need more than standard crypto signals.",
      },
      {
        question: "When will Trend Genie Nova launch?",
        answer:
          "Trend Genie Nova is currently listed as coming soon. Follow Trend Genie's official channels to be notified when Nova becomes available at nova.trendgenie.io.",
      },
      {
        question: "How is Nova different from the Trend Genie Android app?",
        answer:
          "The Android app focuses on real-time AI crypto signal generation for everyday traders. Nova is designed to go deeper by offering advanced market intelligence, expanded analytical capabilities, and premium tooling for traders who want more sophisticated analysis beyond standard signals.",
      },
      {
        question: "Do I need to use the Android app before trying Nova?",
        answer:
          "Not necessarily. Nova will be its own product, but it is designed to work best as part of the wider Trend Genie ecosystem alongside the Android signals app and RugShield token scanner.",
      },
    ],
    relatedKeys: ["android-app", "rugshield-web", "social"],
  },
];

export function getProductByKey(key) {
  return products.find((product) => product.key === key);
}
